import {get} from 'lodash'
import {getUrlVars} from  'powtoon-commons/utils'

export const getPowtoonId = () => {
  const fromStudioURL = get(window.location.hash.match(/\/edit\/(\w*).?$/), '[1]')
  const {powtoon: fromIframeURL} = getUrlVars()
  return fromStudioURL || fromIframeURL
}